document.documentElement.classList.remove('no-js');
(function () {
  'use strict';
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* ---------- Menú lateral ---------- */
  function initDrawer() {
    var d = $('#vuDrawer'); if (!d) return;
    function open() { d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false'); document.documentElement.style.overflow = 'hidden'; }
    function close() { d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); document.documentElement.style.overflow = ''; }
    $$('[data-vu-drawer-open]').forEach(function (b) { b.addEventListener('click', open); });
    $$('[data-vu-drawer-close]', d).forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    $$('.vu-loc').forEach(function (l) {
      var b = $('.vu-loc__btn', l); if (!b) return;
      b.addEventListener('click', function () { l.classList.toggle('is-open'); b.setAttribute('aria-expanded', l.classList.contains('is-open')); });
      $$('a[data-value]', l).forEach(function (a) {
        a.addEventListener('click', function (e) {
          e.preventDefault(); var f = a.closest('form'); if (!f) return;
          var inp = $('input[name="' + a.getAttribute('data-input') + '"]', f); if (inp) { inp.value = a.getAttribute('data-value'); f.submit(); }
        });
      });
    });
  }

  /* ---------- Deslizador base (galería y carruseles) ---------- */
  function slider(root, opts) {
    var vp = $('.' + opts.vp, root), track = $('.' + opts.track, root); if (!vp || !track) return null;
    var slides = $$('.' + opts.slide, track); if (!slides.length) return null;
    var idx = 0, prev = $('[data-vu-prev]', root), next = $('[data-vu-next]', root), dotsWrap = $('[data-vu-dots]', root);
    var dots = [];
    if (dotsWrap) {
      dotsWrap.innerHTML = '';
      slides.forEach(function (_, i) {
        var b = document.createElement('button'); b.type = 'button'; b.className = 'vu-dot'; b.setAttribute('aria-label', 'Ir a ' + (i + 1));
        b.addEventListener('click', function () { go(i); }); dotsWrap.appendChild(b); dots.push(b);
      });
    }
    function step() { var g = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0; return slides[0].getBoundingClientRect().width + g; }
    function perView() {
      var s = step(); if (!s) return 1; var cs = getComputedStyle(vp);
      var w = vp.clientWidth - (parseFloat(cs.paddingLeft) || 0) - (parseFloat(cs.paddingRight) || 0);
      return Math.max(1, Math.floor((w + 20) / s));
    }
    function max() { return Math.max(0, slides.length - (opts.single ? 1 : perView())); }
    function render() {
      var x = -idx * step(); var t = 'translate3d(' + x + 'px,0,0)';
      if (track.style.transform !== t) track.style.transform = t;
      if (prev) prev.hidden = idx <= 0 && !opts.loop;
      if (next) next.hidden = idx >= max() && !opts.loop;
      var m = max();
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); var h = i > m; if (d.hidden !== h) d.hidden = h; });
      if (opts.onChange) opts.onChange(idx);
    }
    function go(i) {
      var m = max();
      if (opts.loop) { i = i < 0 ? m : (i > m ? 0 : i); } else { i = Math.max(0, Math.min(m, i)); }
      idx = i; render();
    }
    if (prev) prev.addEventListener('click', function () { go(idx - 1); });
    if (next) next.addEventListener('click', function () { go(idx + 1); });
    var sx = 0, sy = 0, dx = 0, drag = false, lock = null;
    vp.addEventListener('touchstart', function (e) { var t = e.touches[0]; sx = t.clientX; sy = t.clientY; dx = 0; drag = true; lock = null; track.style.transition = 'none'; }, { passive: true });
    vp.addEventListener('touchmove', function (e) {
      if (!drag) return; var t = e.touches[0]; dx = t.clientX - sx; var dy = t.clientY - sy;
      if (lock === null && (Math.abs(dx) > 6 || Math.abs(dy) > 6)) lock = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
      if (lock === 'x') track.style.transform = 'translate3d(' + (-idx * step() + dx) + 'px,0,0)';
    }, { passive: true });
    vp.addEventListener('touchend', function () {
      if (!drag) return; drag = false; track.style.transition = '';
      if (lock === 'x' && Math.abs(dx) > 40) { go(idx + (dx < 0 ? 1 : -1)); } else { render(); }
    });
    var rt; window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(function () { if (idx > max()) idx = max(); render(); }, 120); });
    render();
    return { go: go, get: function () { return idx; } };
  }

  function initGallery() {
    $$('[data-vu-gallery]').forEach(function (g) {
      var thumbs = $$('.vu-gal__th', g);
      var s = slider(g, { vp: 'vu-gal__vp', track: 'vu-gal__track', slide: 'vu-gal__slide', single: true,
        onChange: function (i) { thumbs.forEach(function (t, j) { t.classList.toggle('is-active', i === j); }); } });
      thumbs.forEach(function (t, j) { t.addEventListener('click', function () { if (s) s.go(j); }); });
    });
  }
  function initCarousels() {
    $$('[data-vu-carousel]').forEach(function (c) {
      slider(c, { vp: 'vu-car__vp', track: 'vu-car__track', slide: 'vu-car__slide', loop: c.hasAttribute('data-loop') });
    });
  }

  /* ---------- Acordeones ---------- */
  function initAcc() {
    $$('[data-vu-toggle]').forEach(function (b) {
      b.addEventListener('click', function () {
        var it = b.closest('[data-vu-item]'); if (!it) return;
        var open = !it.classList.contains('is-open'); it.classList.toggle('is-open', open); b.setAttribute('aria-expanded', open);
      });
    });
  }

  /* ---------- Packs + botón contra entrega ---------- */
  window.VU_SELECTED_IDX = 0;
  function initPacks() {
    var root = $('#vuPacks'); if (!root) return;
    var cards = $$('.vub-card', root);
    window.vuSelectPack = function (i) {
      i = parseInt(i, 10) || 0; window.VU_SELECTED_IDX = i;
      cards.forEach(function (c) { var on = parseInt(c.getAttribute('data-idx'), 10) === i; c.classList.toggle('is-sel', on); var r = $('input', c); if (r) r.checked = on; });
      var qty = $('[data-vu-qty]'); var card = cards.filter(function (c) { return parseInt(c.getAttribute('data-idx'), 10) === i; })[0];
      if (qty && card) qty.value = card.getAttribute('data-qty') || '1';
    };
    cards.forEach(function (c) { c.addEventListener('click', function () { window.vuSelectPack(c.getAttribute('data-idx')); }); });
    var pre = cards.filter(function (c) { return c.hasAttribute('data-default'); })[0];
    window.vuSelectPack(pre ? pre.getAttribute('data-idx') : 0);
  }

  function initReleasit() {
    var host = document.getElementById('vuReleasitHost'); if (!host) return;
    var root = host.closest('[data-cta-bg]') || host, d = root.dataset;
    var S = { 'background': d.ctaBg, 'background-color': d.ctaBg, 'color': d.ctaColor, 'border-radius': d.ctaRadius, 'border': '0',
      'box-shadow': 'none', 'font-size': d.ctaSize, 'font-weight': d.ctaWeight, 'font-family': d.ctaFont,
      'min-height': '56px', 'padding': d.ctaPadding, 'width': '100%', 'margin': '0', 'animation': 'none' };
    var mo = null, runs = 0, win = 0, OBS = { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'class'] };
    function dress() {
      var now = Date.now(); if (now - win > 10000) { win = now; runs = 0; }
      if (++runs > 25) { if (mo) { mo.disconnect(); mo = null; } return; }
      if (mo) mo.disconnect();
      try {
        $$('._rsi-buy-now-button', host).forEach(function (b) {
          for (var k in S) { if (S[k] && b.style.getPropertyValue(k) !== S[k]) b.style.setProperty(k, S[k], 'important'); }
          if (b.classList.contains('_rsi-buy-now-button-shaker')) b.classList.remove('_rsi-buy-now-button-shaker');
          $$('svg', b).forEach(function (svg) { if (svg.getAttribute('fill') !== S.color) svg.setAttribute('fill', S.color); });
          $$('span', b).forEach(function (sp) { if (sp.style.getPropertyValue('color') !== S.color) sp.style.setProperty('color', S.color, 'important'); });
        });
      } catch (e) {}
      if (mo) { try { mo.observe(host, OBS); } catch (e) {} }
    }
    if (window.MutationObserver) { mo = new MutationObserver(dress); mo.observe(host, OBS); }
    dress();
    [300, 1000, 2500, 5000].forEach(function (ms) { setTimeout(dress, ms); });
    window.addEventListener('load', dress);

    var RSI_MODAL = '#_rsi-cod-form-modal._rsi-cod-form-modal-open', RSI_OFFER = '._rsi-quantity-offers-offer-container', RSI_SEL = '_rsi-quantity-offers-selected';
    var syncing = false;
    function sync() {
      if (syncing) return; syncing = true;
      var t0 = Date.now(), done = false, obs = null, clicks = 0, last = 0;
      function finish() { done = true; syncing = false; if (obs) { obs.disconnect(); obs = null; } }
      function apply() {
        if (done) return true;
        if (!document.querySelector(RSI_MODAL)) return false;
        var offers = document.querySelectorAll(RSI_OFFER); if (!offers.length) return false;
        var el = offers[window.VU_SELECTED_IDX | 0]; if (!el) { finish(); return true; }
        if (el.classList.contains(RSI_SEL) || el.querySelector('.' + RSI_SEL)) { finish(); return true; }
        var target = el.querySelector('._rsi-quantity-offers-offer') || el;
        if (clicks < 6 && Date.now() - last > 250) { clicks++; last = Date.now(); try { target.click(); } catch (e) {} }
        return false;
      }
      if (apply()) return;
      if (window.MutationObserver) {
        obs = new MutationObserver(function () { if (apply()) return; if (Date.now() - t0 > 6000) finish(); });
        obs.observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
      }
      (function poll() { if (done) return; if (apply()) return; if (Date.now() - t0 > 6000) { finish(); return; } setTimeout(poll, 150); })();
    }
    document.addEventListener('click', function (e) {
      var h = document.getElementById('vuReleasitHost'); if (!h || !e.target || !e.target.closest) return;
      var t = e.target.closest('._rsi-buy-now-button'); if (t && h.contains(t)) sync();
    }, true);
  }

  /* ---------- Reseñas ---------- */
  function initReviews() {
    $$('[data-vuw-rev]').forEach(function (w) {
      var items = $$('.vuw-it', w), per = parseInt(w.getAttribute('data-per'), 10) || 5;
      var pages = Math.max(1, Math.ceil(items.length / per)), pag = $('.vuw-pag', w), cur = 1;
      function show(p) {
        cur = Math.max(1, Math.min(pages, p));
        items.forEach(function (it, i) { it.hidden = !(i >= (cur - 1) * per && i < cur * per); });
        if (pag) $$('button[data-p]', pag).forEach(function (b) { b.classList.toggle('is-active', parseInt(b.getAttribute('data-p'), 10) === cur); });
      }
      if (pag) {
        $$('button[data-p]', pag).forEach(function (b) { b.addEventListener('click', function () { var p = parseInt(b.getAttribute('data-p'), 10); if (p <= pages) { show(p); w.scrollIntoView({ block: 'start' }); } }); });
        var pv = $('[data-vuw-prev]', pag), nx = $('[data-vuw-next]', pag);
        if (pv) pv.addEventListener('click', function () { show(cur - 1); });
        if (nx) nx.addEventListener('click', function () { show(cur + 1); });
      }
      show(1);
      var m = $('.vuw-modal', w);
      $$('[data-vuw-open]', w).forEach(function (b) { b.addEventListener('click', function () { if (m) m.classList.add('is-open'); }); });
      if (m) {
        $$('[data-vuw-close]', m).forEach(function (b) { b.addEventListener('click', function () { m.classList.remove('is-open'); }); });
        m.addEventListener('click', function (e) { if (e.target === m) m.classList.remove('is-open'); });
        var f = $('form', m); if (f) f.addEventListener('submit', function (e) { e.preventDefault(); var ok = $('.vuw-modal__ok', m); if (ok) ok.style.display = 'block'; f.reset(); });
      }
    });
  }

  function init() { initDrawer(); initGallery(); initCarousels(); initAcc(); initPacks(); initReleasit(); initReviews(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
